const columnDataMKM = [
  {
    dataField: 'commonNumberMKM',
    caption: 'Общий номер',
    dataType: 'string'
  }

];

export default columnDataMKM;
